const customVueComponents = {
    "custom-price": {
        data() {
            return {
                count: 0,
            };
        },
        methods: {
            formatMoney(price) {
                return Shopify.formatMoney(price);
            },
            getDiscountProduct(item) {
                // return a
                return item.original_price != item.price;
            },
        },
        computed: {
            getPrice() {
                const sku = this.sku || (this.product ? this.product?.sku : "");
                return this.free
                    ? 0
                    : store.state.listaPrecios.find((x) => x.SKU == sku)
                          ?.Precio * 100 ||
                            this.product?.price ||
                            this.price;
            },
            getDiscount() {
                return store.state.customer.discount;
            },
            isWholesale() {
                return store.state.customer.isWholesale;
            },
            numItems() {
                return store.state.cart?.data?.item_count * this.price;
            },
            total() {
                return Shopify.formatMoney(store.state.cart?.data?.total_price);
            },
            getBoolDiscount() {
                const bool1 =
                    !store.state.customer.isWholesale &&
                    store.state.cart?.data?.items.some(
                        (x) => x.selling_plan_allocation
                    );
                return /* store.state.customer.isWholesale && */ /* store.state.customer.discount < 1 &&  */ !bool1;
            },
        },
        props: [
            "quantity",
            "sku",
            "free",
            "price",
            "money_price",
            "classes",
            "classes_after",
            "product",
            "hide_before",
            "hide_dsc_tag",
            "original_price",
            "show_dsc",
        ],
        template: `
        
  <template v-if="!hide_dsc_tag">
  
      <div class="descuento-especial caption" v-if="product?.discount">
          <div class="align-items-center flex font-header gap-0-5rem p-5px">
              <i class="fas fa-tags"></i>
              <span class="dsc-title"> {{product?.discount.name}}</span>
          </div>
      </div>
  </template>
  
  <template v-if="getBoolDiscount || show_dsc">
      <template v-if="original_price != price  && original_price">
  
          <!-- v-if -->
          <div class="price bold w-100" v-bind:class="[classes_after]">
              {{ product?.priceFormatted }}
          </div>
  
          <div>
              <span class="visually-hidden visually-hidden--inline price price-item"></span>
          </div>
          <span v-if="!hide_before">
              <s v-bind:class="[classes, 'price-item--sale']">{{ formatMoney(product?.original_price) }} </s>
          </span>
      </template>
      <template v-else-if="isWholesale && (sku || (product ?  product.sku : false)) || free">
        <template v-if="price != getPrice">
          <div class="no-js">
            QTY:{{ quantity }}
            getPrice:{{ getPrice }}
          </div>
          <div class="price bold w-100" v-bind:class="[classes_after]">
              {{ formatMoney(getPrice*(quantity || 1)) }}
          </div>
          <div>
              <span class="visually-hidden visually-hidden--inline price price-item"></span>
          </div>
          <span v-if="!hide_before">
              <s v-bind:class="[classes, 'price-item--sale']">{{ formatMoney(price) }} </s>
          </span>
        </template>
        <template v-else>
  
          <div class="price bold w-100 gap-0-5rem" v-bind:class="[classes_after]">
            <div v-if="free && quantity">
              {{ quantity || 1 }} x
            </div>
            <div>
              {{ formatMoney(price) }}
            </div>
          </div>
        </template>
          <!-- v-else-if -->
  
      </template>
      <!-- v-else -->
      <div v-bind:class="[classes]" else1 v-else>
          {{ formatMoney(price) }}
          <!-- 
            {{ sku ||( product? product?.sku : 'NO SKU') }}
            -->
      </div>
  </template>
  
  <div v-bind:class="[classes]" else2 v-else>
  
      {{ formatMoney(price) }}
  </div>
        
            `,

        // <span class>{{numItems}}</span>
    },
    "price-sku": {
        data() {
            return {
                count: 0,
            };
        },
        methods: {
            formatMoney(price) {
                return Shopify.formatMoney(price);
            },
            getPriceSKU(sku) {
                return sku;
            },
        },
        computed: {
            getVariantSelected() {
                return store.state.selectedVariant;
            },
            isWholesale() {
                return store.state.customer.isWholesale;
            },
            getPrice() {
                return (
                    store.state.listaPrecios.find(
                        (x) => x.SKU == store.state.selectedVariant.sku
                    )?.Precio * 100 || store.state.selectedVariant.price
                );
            },
            prueba1() {
                return store.state.listaPrecios.find(
                    (x) => x.SKU == store.state.selectedVariant.sku
                );
            },
            prueba2() {
                return store.state.selectedVariant.sku;
            },
        },
        props: ["sku"],
        template: `
        <template v-if="isWholesale">
            <div class="mb-2">
                <legend class="form__label">Precio de venta</legend>
                <span class="bold text-large light">{{ formatMoney(getVariantSelected.price) }}</span>
            </div>
            <div class="flex gap-0-5rem" style="gap: 2rem;">
                <div class="">
                    <legend class="form__label">Tu precio</legend>
                    <span class=" bold text-large" style="padding: 1rem 1rem;">
                        {{ formatMoney(getPrice)}}
                    </span>
                </div>
                <div class="">
                    <legend class="form__label">Tu ganancia</legend>
                    <span class="bold text-large text-color-accent-1" style="padding: 1rem 1rem;">
                        {{ formatMoney(getVariantSelected.price-getPrice) }}
                    </span>
                </div>
            </div>
        </template>
        <template v-else>
        <div class="mb-2">
        <legend class="form__label">Precio</legend>
        <span class="bold text-large">{{ formatMoney(getVariantSelected.price) }}</span>
        </div>
        </template>
  
            `,
    },
};

const mountVueComponent = (app, name) => {
    return app.component(name, customVueComponents[name]);
};

const checkAgregarMultiploProductos = (sku, qty, multiplo) => {
    const agregar = Math.floor(qty / multiplo);

    if (agregar > 0) {
        return {
            sku,
            qty: agregar,
            quantity: agregar,
        };
    } else {
        return null;
    }
};

let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});

document.querySelector(".eye-password")?.addEventListener("click", function () {
    const input = this.parentElement.querySelector("input");
    const classes = this.classList; //.split(/\s+/)

    const show = classes.contains("hide-password");

    if (show) {
        this.classList.remove("hide-password");
        this.classList.remove("fa-eye");
        this.classList.add("fa-eye-slash");

        input.setAttribute("type", "text");
    } else {
        this.classList.add("hide-password");
        this.classList.add("fa-eye");
        this.classList.remove("fa-eye-slash");

        input.setAttribute("type", "password");
    }
});

const padSize = (text, size) => {
    text = `${text ?? ""}`;

    let str = text.includes("-") ? text.split("-")[1] : text;
    let str2 = text.includes("-") ? text.split("-")[0] : "";

    let prefix2 = text.includes("-") ? "-" : "";

    size = size || str.length;
    const num = parseInt(str);
    const prefix = str2;
    let s = num + "";
    while (s.length < size) {
        s = "0" + s;
    }
    return `${prefix}${prefix2}${s}`;
};

function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  document.querySelector('body').addEventListener('click',function(e){

    let target = e.target.parentElement.parentElement.nodeName
    // console.log('target :>> ', target);
    // document.getElementById('clickbox').contains
    
    let details = document.querySelector('.facets__disclosure[open]')

    if(details && target != 'SUMMARY'){
        // console.log('details :>> ', details);
        details.removeAttribute('open')
    }
    // console.log('Click');

  })